import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:id/update(/:view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/PracticeTemplateUpdateContainer',
      './modules/PracticeTemplateUpdate'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PracticeTemplateUpdate = require('./containers/PracticeTemplateUpdateContainer').default
      const actions = require('./modules/PracticeTemplateUpdate')
      const reducer = require('./modules/PracticeTemplateUpdate').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'CreatePracticeTemplate', reducer: reducer })

      store.dispatch(actions.initialize())
    //   store.dispatch(actions.fetchFeatures())
      store.dispatch(actions.fetchPracticeTemplate(nextState.params.id, nextState.params.view))
      /*  Return getComponent   */
      cb(null, PracticeTemplateUpdate)

      /* Webpack named bundle   */
    }, 'CreatePracticeTemplate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/index.js